module.exports = __webpack_public_path__ + "static/img/gaozhonglishi2.eab4fc7d.jpg";